import { render, staticRenderFns } from "./ObjectDetailLight.vue?vue&type=template&id=451151c5&scoped=true&"
import script from "./ObjectDetailLight.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailLight.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDetailLight.vue?vue&type=style&index=0&id=451151c5&scoped=true&lang=scss&"
import style1 from "./ObjectDetailLight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451151c5",
  null
  
)

export default component.exports